const counters = {
	el: {
		title: $('.content__block-image-text--orange'),
		counter: $('.js-counter')
	},
	events() {

		this.el.counter.counterUp({
			delay: 50,
			time: 1500,
			formatter: n => {
				return n.replace(/,/g, '.');
			}
		});

		this.el.title.hasClass('js-counter') ? this.el.title.closest('.general-content').find('.content__image').css('box-shadow', 'none') : ''

	},
	init() {
		this.events()
	}
}

counters.init()